/*
 * © 2020 Microsoft. All rights reserved.
 */

define('MenuUI/ChallengeHud',['pixi', 'absolute/threeslice', 'absolute', 'Managers/ScaleManager'],
	function (PIXI, ThreeSlice, Absolute, ScaleManager) {
		var ChallengeHud = function (hudType, height) {
			this.init(hudType, height);
		};
		ChallengeHud.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);
		ChallengeHud.prototype.init = function (hudType) {
			PIXI.DisplayObjectContainer.call(this);
			this.huds = [];
			switch (hudType) {
				case 1:
					this.initOneHud();
					break;
				case 2:
					this.initTwoHuds();
					break;
				case 3:
					this.initThreeHuds();
					break;
				default:
					this.initSingleHud();
					break;
			}
			this.challengeHudHeight = this.height;
			this.challengeHudWidth = this.width;
		};


		ChallengeHud.prototype.initOneHud = function () {
			this.addChild(this.initSingleHud());
		};

		ChallengeHud.prototype.initTwoHuds = function () {
			var first = this.initSingleHud();
			var second = this.initSingleHud();
			second.x = first.x + first.width;
			this.addChild(first);
			this.addChild(second);
		};

		ChallengeHud.prototype.initThreeHuds = function () {
			var first = this.initSingleHud();
			var second = this.initSingleHud();
			var third = this.initSingleHud();
			second.x = first.x + first.width - Absolute.Coords.x(5);
			third.x = second.x + second.width;
			this.addChild(first);
			this.addChild(second);
			this.addChild(third);
		};

		ChallengeHud.prototype.initSingleHud = function () {
			var hud = new PIXI.DisplayObjectContainer();
			var leftBackground = this.initLeft();
			hud.addChild(leftBackground);
			var rightBackground = this.initRight();
			hud.addChild(rightBackground);
			rightBackground.x = leftBackground.x + leftBackground.width;
			hud.rightBackground = rightBackground;
			hud.leftBackground = leftBackground;
			this.huds.push(hud);
			return hud;
		};

		ChallengeHud.prototype.setLabel = function (label, index) {
			label.x = this.huds[index].x + (this.huds[index].leftBackground.width - label.width) / 2 + Absolute.Coords.x(10);
			label.y = (this.height - label.height) / 2 - Absolute.Coords.y(3);
			this.huds[index].label = label;
			this.addChild(label);
		};

		ChallengeHud.prototype.setData = function (data, index) {
			var dataOffset = Absolute.Coords.x(5);
			this.huds[index].rightBackground.addChild(data);
			this.huds[index].data = data;
			this.huds[index].data.x = ((this.huds[index].rightBackground.width - this.huds[index].data.width) / 2) - dataOffset;
		};

		ChallengeHud.prototype.initLeft = function () {
			var leftOptions = {
				width: '90',
				images: {
					left: 'challenge_left_cap.png',
					center: 'challenge_left_stretch.png',
					right: 'challenge_left_stretch.png'
				}
			};
			return this._generateThreeSliceAsset(leftOptions);
		};

		ChallengeHud.prototype.initRight = function () {
			var rightOptions = {
				width: '120',
				images: {
					left: 'challenge_mid_cap.png',
					center: 'challenge_right_stretch.png',
					right: 'challenge_right_cap.png'
				}
			};
			return this._generateThreeSliceAsset(rightOptions);
		};

		ChallengeHud.prototype.handleResize = function () {
			var yScale = Math.max(Math.min((ScaleManager.height / 1080) + 0.3, 1), 0.5),
				xScale = Math.max(Math.min((ScaleManager.width / 1920) + 0.3, 1), 0.5),
				resizeScale = Math.min(yScale, xScale);
			var height = resizeScale * (this.challengeHudHeight / ScaleManager.scaleFactorY);
			var width = resizeScale * (this.challengeHudWidth / ScaleManager.scaleFactorX);
			this.width = width;
			this.height = height;
			this.huds.forEach(function (hud) {
				var dataOffset = Absolute.Coords.x(5);
				hud.data.y = ((hud.height - hud.data.height) / 2) + Absolute.Coords.y(3) * resizeScale;
				hud.label.y = ((hud.height - hud.label.height) / 2) + Absolute.Coords.y(3) * resizeScale;
				hud.data.position.x = ((hud.rightBackground.width - hud.data.width) / 2) - dataOffset;
			});
		};

		ChallengeHud.prototype._generateThreeSliceAsset = function (options) {
			var threeSlice = new ThreeSlice(options);
			return threeSlice;
		};

		return ChallengeHud;
	});

